// extracted by mini-css-extract-plugin
module.exports = {"tablet":"768px","container":"HeroVideo_container__5QBrS","video":"HeroVideo_video__JWl3i","desktop":"HeroVideo_desktop__TVwsD","mobile":"HeroVideo_mobile__sA82I"};